import React from 'react';
import Icon from '../Icon';
import { ButtonStates } from '../../constants';
import clsx from 'clsx';
import { translate } from '../../Services/translation';

const BuyButton = ({ label = '', onClick, disabled, state, className }) => {
  const getIconFromState = () => {
    switch (state) {
      case ButtonStates.Success:
        return 'Check';
      case ButtonStates.Loading:
        return 'Refresh';
      case ButtonStates.Error:
        return 'Caution-Circle-Filled';
      case ButtonStates.Empty:
        return '';
      default:
        return 'Cart';
    }
  };

  const getLabelFromState = () => {
    switch (state) {
      case ButtonStates.Success:
        return '';
      case ButtonStates.Loading:
        return '';
      case ButtonStates.Error:
        return label ? translate('buybutton.error') : '';
      default:
        return label;
    }
  };

  return (
    <button
      className={clsx(
        'buy-button',
        state ? 'buy-button--' + state : '',
        className
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon name={getIconFromState()} size={24} className="buy-button__icon" />
      {getLabelFromState()}
    </button>
  );
};

export default BuyButton;
